
import api from '../../utils/api'

const API_BASE_URL = "/geo/GEOState";

const GEOStateService = {
    async findAll(): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/find-all`);
        return response.data;
    },

    async getItemById(countryCode: string, stateCode: string): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/find-one/${countryCode}/${stateCode}`);
        return response.data;
    },

    async create(item: any): Promise<any> {
        const response = await api.post(`${API_BASE_URL}/create`, item);
        return response.data;
    },

    async update(countryCode: string, stateCode: string, item: any): Promise<any> {
        const response = await api.put(`${API_BASE_URL}/update/${countryCode}/${stateCode}`, item);
        return response.data;
    },

    async delete(countryCode: string, stateCode: string): Promise<any> {
        const response = await api.delete(`${API_BASE_URL}/delete/${countryCode}/${stateCode}`);
        return response.data;
    },

    async getDropdownByCountryCode(countryCode: string): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/get-dropdown-by-country/${countryCode}`);
        return response.data;
    },
};

export default GEOStateService;